import {Component, OnInit} from '@angular/core';
import {UserModel} from '../../../../models/authentication/user.model';
import {SchoolModel} from '../../../../models/school/school.model';
import {SchoolAdminService} from '../../../../services/school/school-admin.service';
import {MobileMenuService} from '../../../../mobile/mobile-menu/mobile-menu.service';

@Component({
  selector: 'app-school-admin-mobile-sidebar',
  templateUrl: './school-admin-mobile-sidebar.component.html',
  styleUrls: ['./school-admin-mobile-sidebar.component.css']
})
export class SchoolAdminMobileSidebarComponent implements OnInit {

  constructor(private schoolSv: SchoolAdminService,
              public mobileSv: MobileMenuService) {
  }

  ngOnInit() {

    this.schoolSv.fetchSchool(SchoolModel.getCurrent()._id).subscribe((school) => {
      SchoolModel.setCurrent(school);
    });

  }

  isPartOfSchool(): boolean {

    // TODO Implemented school check

    return true;
  }

  userFullName(): string {

    if (UserModel.getCurrent()) {

      return UserModel.getCurrent().firstName + ' ' + UserModel.getCurrent().lastName;
    }

    return '';
  }

  userEmail(): string {

    if (UserModel.getCurrent()) {
      return UserModel.getCurrent().email;
    }

    return '';

  }

  schoolName(): string {

    if (SchoolModel.getCurrent()) {
      return SchoolModel.getCurrent().name;
    }

    return null;
  }

}
